import { Component, input, computed } from '@angular/core';
import { DatePipe } from '@angular/common';
import { OrderComment } from '../../order.model';

@Component({
  selector: 'app-comment-bubble',
  standalone: true,
  imports: [DatePipe],
  templateUrl: './comment-bubble.component.html',
  styleUrl: './comment-bubble.component.css'
})
export class CommentBubbleComponent {
  comment = input.required<OrderComment>();
  isCurrentUser = input.required<boolean>();

  isEdited = computed(() => 
    this.comment().updatedAt.toMillis() > this.comment().createdAt.toMillis()
  );
}